import {
  Paper,
  Badge,
  Flex,
  SegmentedControl,
  Stack,
  Button,
  Divider,
  Text,
  SimpleGrid,
  Title,
  NumberFormatter,
} from "@mantine/core";
import { useState } from "react";
import { FeatureChecklist, FeatureChecklistItem } from "./FeatureSection";
import classes from "./PricingBoxes.module.css";
import { checkout } from "../api";

const PlanBox = ({ isActive, plan, interval, highlight, action }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Paper
      shadow={highlight ? "lg" : "sm"}
      p="lg"
      radius="md"
      withBorder
      style={{
        borderColor: isActive ? "#c0d4ff" : "#e0e0e0",
        scale: highlight ? 1.05 : 1,
      }}
      className={classes.root}
    >
      <Stack style={{ flexGrow: 1 }} align="center">
        <Text ta="center" fw={700} fz="xl">
          {plan.title}
        </Text>

        {isActive && <Badge>Active Plan</Badge>}

        {interval == "annual" && (
          <Title
            order={3}
            ta="center"
            c="dimmed"
            style={{
              fontSize: 24,
              gap: 2,
            }}
            td="line-through"
          >
            <NumberFormatter
              value={plan.price["monthly"] * 12}
              prefix="$ "
              thousandSeparator
            />
          </Title>
        )}

        <Title
          order={2}
          ta="center"
          style={{
            fontSize: 50,
            gap: 5,
          }}
        >
          <NumberFormatter
            value={plan.price[interval]}
            prefix="$ "
            thousandSeparator
          />
        </Title>

        <Text ta="center" fz="sm" c="dimmed">
          Billed {interval == "monthly" ? "monthly" : "annually"}
        </Text>

        <Divider
          style={{
            width: "100%",
            // borderColor: colorScheme === "dark" && "gray",
            // opacity: colorScheme === "dark" && 0.7,
          }}
        />

        <FeatureChecklist>
          {plan.features.map((item) => (
            <FeatureChecklistItem key={item.id} text={item.text} />
          ))}
        </FeatureChecklist>

        <Button
          mt="auto"
          disabled={isActive}
          loading={isLoading}
          variant={highlight ? "filled" : "outline"}
          size="lg"
          onClick={() => {
            setIsLoading(true);
            checkout({ planName: plan.stripeName || plan.title, interval }, () =>
              setIsLoading(false)
            );
          }}
          // component="a"
          // href="https://app.optivise.io/auth/register"
          // target="_blank"
          fullWidth
        >
          {action || "Subscribe"}
        </Button>
      </Stack>
    </Paper>
  );
};

export const PricingBoxes = ({ currentPlan }) => {
  const [interval, setInterval] = useState("monthly");

  const plan2 = {
    title: "Brand",
    stripeName: "Growth",
    id: "growth",
    features: [
      { id: 1, text: "1 brand, 10 categories we watch" },
      { id: 2, text: "2 researched topical clusters / month" },
      { id: 3, text: "500 classified web mentions / month" },
      { id: 4, text: "Six AI engines, Search Console, analytics" },
      { id: 5, text: "Extra cluster $19 · more mentions $29/mo" },
    ],
    price: { monthly: 99, annual: 948 },
  };

  const plan3 = {
    title: "Company",
    stripeName: "Business",
    id: "business",
    features: [
      { id: 1, text: "3 brands, 25 categories we watch" },
      { id: 2, text: "5 researched topical clusters / month" },
      { id: 3, text: "1,500 classified web mentions / month" },
      { id: 4, text: "Everything in Brand" },
    ],
    price: { monthly: 199, annual: 1788 },
  };

  return (
    <Stack gap="lg" my="sm">
      <Flex direction="column" gap={4} align="center" justify="start">
        <SegmentedControl
          value={interval}
          onChange={setInterval}
          data={[
            { label: "Annual", value: "annual" },
            { label: "Monthly", value: "monthly" },
          ]}
        />
        <Text>Save over 20% on annual plans!</Text>
      </Flex>
      <SimpleGrid
        cols={{ base: 1, sm: 2 }}
        direction={{ base: "column", md: "row" }}
        gap="xl"
      >
        <PlanBox
          isActive={currentPlan === plan2.stripeName}
          plan={plan2}
          interval={interval}
          highlight
          action="Start free trial — one cluster"
        />
        <PlanBox
          isActive={currentPlan === plan3.stripeName}
          plan={plan3}
          interval={interval}
        />
      </SimpleGrid>
    </Stack>
  );
};
